import { useUser } from "src/contexts/user-context";
import { usePersistedState } from "src/hooks/use-persisted-state";

export const SUPPORTED_AGENTS_MODELS = [
  "gpt-oss-120b",
  "claude-sonnet-4-5",
  "claude-opus-4-5-20251101",
  "claude-haiku-4-5-20251001",
  "opus",
  "sonnet",
  "minimax-m2p1",
] as const;

type Settings = {
  isDevMode: boolean;
  // Allow any string so users can enter custom model names not in the supported list
  model?: string;
  showAllSessions?: boolean;
};

export const useDevSettings = (): {
  settings: Settings;
  setSettings: (settings: Partial<Settings>) => void;
} => {
  const { workspace } = useUser();

  const settings = usePersistedState<Settings>(
    `${workspace?.id}.agents.settings`,
    {
      isDevMode: false,
      model: undefined,
    },
  );

  const isDevMode = settings.value?.isDevMode ?? false;
  const model = settings.value?.model;
  const showAllSessions = settings.value?.showAllSessions ?? false;

  return {
    settings: { isDevMode, model, showAllSessions },
    setSettings: (updates: Partial<Settings>) => {
      settings.set({ ...settings.value!, ...updates });
    },
  };
};
